export default __webpack_public_path__ + "static/banner-wedding-post-wedding-cash-splash-7ff27b5364a2b961386f1d9e5f32e4fe.jpg";